import { Flex, Icon } from '@/_components';
import { FC } from 'react';
import styles from './UploadedFileIndicator.module.css';
import { UploadedFileIndicatorProps } from './UploadedFileIndicator.types';
import { getClasses } from '@/_utils/classnames';
import { IconType } from '@/_types/icons';
import { Loading } from '@/_components/Loading';

export const UploadedFileIndicator: FC<UploadedFileIndicatorProps> = ({
  isComplete,
  isWaiting,
  isAdditional,
  isLoading,
}) => {
  const uploadFileIndicatorClasses: string = getClasses(
    styles.uploadedFileIndicator,
    {
      [styles.uploadedFileIndicatorComplete]: isComplete,
      [styles.uploadedFileIndicatorAdditional]: isAdditional,
      [styles.uploadedFileIndicatorWaiting]: isWaiting,
      [styles.uploadedFileIndicatorLoading]: isLoading,
    },
  );

  const icon: IconType = isAdditional
    ? 'files'
    : isComplete
      ? 'check-circle'
      : isWaiting
        ? 'clock'
        : 'circle';

  return (
    <Flex className={uploadFileIndicatorClasses} isCentered={true}>
      {isLoading ? <Loading size={24} /> : <Icon name={icon} size={24} />}
    </Flex>
  );
};
